import { ReactElement } from "react";
import { IContentAreaProps, IFilterData, IState } from "../../../../types";
import FilterComponentBase from "../../../../components/filterComponentBase";
import { Alert } from "@mui/material";
import { IPowerOnOffReport } from "../types";
import AvgPowerOnOffChart from "./components/avgPowerOnOffChart";
import CountOfHeatsChart from "./components/countOfHeatsChart";
import HeatTable from "./components/heatTable";
import { useSelector } from "react-redux";
import { useFetch } from "../../../../system/useFetch";
import SkeletonView from "../../../../components/skeletonView";

const Index = ({ parentSize }: IContentAreaProps): ReactElement => {
  const filter = useSelector<IState, IFilterData>(state => state.filter);
  const { loading, error, data: reportData } = useFetch<IPowerOnOffReport[]>({ module: "meltShop", query: "getPowerOnOffReport", payload: { ...filter.remote } });

  const layoutStyle = {
    ...parentSize,
    gridTemplateRows: "auto 1fr",
    gridTemplateColumns: "1fr",
  };

  const subLayoutStyle = {
    gridTemplateRows: "1fr 1fr 1fr",
    gridTemplateColumns: "40% 1fr",
    padding: "1em"
  };

  const tableAreaStyle = {
    gridRow: "1 / span 3",
    overflow: "scroll",
  };

  const isMobile = parentSize.width < 400 || parentSize.height < 400;

  return (
    <div className="display-grid" style={layoutStyle}>
      <FilterComponentBase loading={loading}/>

      {loading && <SkeletonView  parentSize={parentSize}/>}
      {error && <Alert severity="warning">{error.message}</Alert>}
      {!loading && !error && !reportData && <Alert severity="warning">No Data to Display.</Alert>}

      {!loading && !error && reportData && !isMobile &&
        <div className="display-grid" style={subLayoutStyle}>

          <div style={tableAreaStyle}>
            <HeatTable data={reportData} parentSize={parentSize} />
          </div>

          <AvgPowerOnOffChart data={reportData}/>

          <CountOfHeatsChart data={reportData}/>

          <div />
        </div>
      }
      {!loading && !error && reportData && isMobile &&
      <div className="p-1" style={{ width: parentSize.width - 16 }}>
        <HeatTable data={reportData} parentSize={parentSize} />
        <AvgPowerOnOffChart data={reportData}/>
        <CountOfHeatsChart data={reportData}/>
      </div>
      }
    </div>
  );
};

export default Index;
